import StatusChip, { ChipType } from 'components/@extended/StatusChip.tsx';
import { t } from 'utils/getTranslations.ts';

type Props = {
    status: string;
};

export const ProjectStatusChip = ({ status }: Props) => {
    const statusChipType: ChipType = (() => {
        switch (status) {
            case 'IN_PROGRESS':
                return 'success';
            case 'COMPLETED':
                return 'neutral';
        }
    })();
    return <StatusChip type={statusChipType} label={t('projects.statuses.' + status)} className="self-start" />;
};
